import * as apiMemberCardPerks from '@/api/memberCardPerks/updateMemberCardPerks';

export default {
	namespaced: true,
	state: () => ({
		loading: false,
	}),
	mutations: {
		isLoading(state, loading) {
			state.loading = loading;
		},
	},
	actions: {
		async update({ commit }, membership) {
			commit('isLoading', true);

			await apiMemberCardPerks.put(membership.id, membership);

			commit('isLoading', false);
		},
	},
	getters: {},
};
